/**
 * Small "migrating" pill shown next to unmigrated nav items — subtle enough
 * not to look broken, with a tooltip explaining the state.
 */
export function MigratingBadge() {
  return (
    <span
      title="moving to the new backend"
      className="ml-2 shrink-0 px-1.5 py-0.5 bg-amber-50 text-amber-600 text-[10px] font-medium uppercase tracking-wide rounded-full border border-amber-200"
    >
      migrating
    </span>
  );
}
